import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@ais-ui/ui-core';
import { VectorTileDeleteService } from './VectorTileDeleteService';
import { VectorTileAddEditService } from './VectorTileAddEditService';
import { useLocalization } from '@ais-ui/locale-management';
import { NoItemsEmptyStateList } from '../../../components/EmptyList';
import React from 'react';
import { useVectorTileSettings } from '../../VectorTiles/useVectorTileSettings';
import { PiGridFour } from 'react-icons/pi';

export const VectorTileListServices = () => {
  const { messages } = useLocalization();
  const vectorTiles = useVectorTileSettings();

  return (
    <Accordion type="single" className="mt-8 space-y-8" collapsible>
      {vectorTiles.length === 0 ? (
        <NoItemsEmptyStateList
          entity="web map service"
          srcImage="empty_list_bro.png"
        >
          <VectorTileAddEditService
            mode={'create'}
            className={'w-[80%] h-10'}
          ></VectorTileAddEditService>
        </NoItemsEmptyStateList>
      ) : (
        vectorTiles.map((vectorTile) => (
          <AccordionItem key={vectorTile.id} value={`item-${vectorTile.id}`}>
            <AccordionTrigger className="group hover:no-underline">
              <div className="flex items-center">
                <PiGridFour className="h-9 w-9" />
                <div className="ml-4 space-y-1">
                  <p className="text-sm text-left font-medium leading-none group-hover:underline">
                    {vectorTile.name}
                  </p>
                  <p className="text-sm text-left text-muted-foreground">
                    {vectorTile.url}
                  </p>
                </div>
              </div>
            </AccordionTrigger>

            <AccordionContent>
              <div className="space-y-8">
                <div className="flex justify-between px-4">
                  <VectorTileDeleteService
                    vectorTile={vectorTile}
                  ></VectorTileDeleteService>
                  <VectorTileAddEditService
                    existingVectorTile={vectorTile}
                    mode="edit"
                  ></VectorTileAddEditService>
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        ))
      )}
    </Accordion>
  );
};
